<template>
  <div class="item">
    <div class="title">{{ name }}</div>
    <div>发票额度: {{ receiptMax }}</div>
    <div>核定普通发票数量: {{ normalReceiptApproved }}</div>
    <div>核定专用发票数量: {{ specialReceiptApproved }}</div>
    <div>剩余普通发票数量: {{ normalReceiptRemaining }}</div>
    <div>剩余专用发票数量: {{ specialReceiptRemaining }}</div>
  </div>
</template>

<script>
  export default {
    name: "ReceiptCountItem",
    props: {
      name: {
        type: String,
        required: true
      },
      receiptMax: {
        type: String,
        default:''
      },
      normalReceiptApproved:{
        type:Number,
        required:true
      },
      specialReceiptApproved:{
        type:Number,
        required:true
      },
      normalReceiptRemaining:{
        type:Number,
        required:true
      },
      specialReceiptRemaining:{
        type:Number,
        required:true
      }
    }
  }
</script>

<style scoped>
  .item {
    border-bottom: 1px solid #D8D8D8;
    padding: 10px 14px;
    font-size: 14px;
    color: #9A9A9A;
    line-height: 26px;
  }

  .item .title {
    font-size: 16px;
    font-weight: bold;
    color: #000;
  }
</style>